module.exports = __webpack_public_path__ + "static/media/Locix_Office_Furniture.c0ff5b39.png";